import store, { MutationName } from '@/store'
import { ToastText } from '@/enums/toast'
import { AxiosError } from 'axios'
import { log } from '@/server/helper/loggerHelper'
import { logError } from '@/apis/log'

export type ExpectedError = string | undefined | AxiosError

export const handleErrorToast = (error: ExpectedError) => {
  if (typeof error === 'string') {
    store.commit(MutationName.SET_TOAST, {
      message: error,
      show: true,
    })
    console.error(error)
    return
  }

  /*
   * @SEE: https://github.com/axios/axios#response-schema
   */
  if (error && error.response && error.response.status) {
    switch (error.response.status) {
      case 400:
        store.commit(MutationName.SET_TOAST, {
          message: ToastText.REQUEST_ERROR,
          show: true,
        })
        break
      case 401:
      case 403:
        store.commit(MutationName.SET_TOAST, {
          message: ToastText.NO_ACCESS_PERMISSION,
          show: true,
        })
        history.go(-1)
        break
      case 404:
        store.commit(MutationName.SET_TOAST, {
          message: ToastText.NOT_FOUND,
          show: true,
        })
        break
      case 500:
      case 501:
      case 502:
      case 503:
        store.commit(MutationName.SET_TOAST, {
          message: ToastText.NOT_FOUND,
          show: true,
        })
        break
      default: {
        store.commit(MutationName.SET_TOAST, {
          message: ToastText.SERVER_ERROR,
          show: true,
        })
      }
    }
    console.error(error)
    return
  }

  store.commit(MutationName.SET_TOAST, {
    message: ToastText.UNEXPECTED_ERROR,
    show: true,
  })

  console.error(error)
  logError({
    message: 'CLIENT_UNEXPECTED_ERROR',
    error: error instanceof Error ? { message: error.message, stack: error.stack } : String(error)
  })
}
